import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import { Message } from 'element-ui'

Vue.use(VueRouter)

const routes = [
  { path: '/login', name: 'Login', component: () => import('../views/Login.vue'), meta: { title: '登入' } },
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: { title: '首頁' }
  },
  {
    path: '/workbench',
    name: 'Workbench',
    component: () => import('../views/Workbench.vue'),
    meta: { title: '圖片工作台 · 圖生圖' }
  },
  {
    path: '/workbench/competitor',
    name: 'WorkbenchCompetitor',
    component: () => import('../views/Workbench.vue'),
    meta: { title: '圖片工作台 · 競品參考' }
  },
  {
    path: '/video',
    name: 'VideoWorkbench',
    component: () => import('../views/VideoWorkbench.vue'),
    meta: { title: '影片工作台 · 圖生影片' }
  },
  {
    path: '/video/remake',
    name: 'VideoRemake',
    component: () => import('../views/VideoWorkbench.vue'),
    meta: { title: '影片工作台 · 影片復刻' }
  },
  {
    // 影片畫質提升：與創作/復刻共用工作台元件，靠路由把技能切過去。
    // 選單裡不單獨列入口（使用者是從頂部「技能入口」下拉切的），但保留路由以便直達/重新整理。
    path: '/video/upscale',
    name: 'VideoUpscale',
    component: () => import('../views/VideoWorkbench.vue'),
    meta: { title: '影片工作台 · 提升畫質' }
  },
  {
    // 影片合成：多段拼接 + 轉場 + 配樂 + 畫中畫。純本地 ffmpeg，不調模型、不收費。
    path: '/video/compose',
    name: 'VideoCompose',
    component: () => import('../views/VideoWorkbench.vue'),
    meta: { title: '影片工作台 · 影片合成' }
  },
  {
    // AI 字幕：識別語音 → 生成字幕 → 燒進畫面（介面先上，後端開發中）
    path: '/video/subtitle',
    name: 'VideoSubtitle',
    component: () => import('../views/VideoWorkbench.vue'),
    meta: { title: '影片工作台 · AI 字幕' }
  },
  {
    // AI 去字幕：擦除畫面上已燒進去的字幕（介面先上，後端開發中）
    path: '/video/erase-subtitle',
    name: 'VideoEraseSubtitle',
    component: () => import('../views/VideoWorkbench.vue'),
    meta: { title: '影片工作台 · AI 去字幕' }
  },
  {
    // AI 語音：文字轉配音 / 影片自動配音（介面先上，後端開發中）
    path: '/video/voice',
    name: 'VideoVoice',
    component: () => import('../views/VideoWorkbench.vue'),
    meta: { title: '影片工作台 · AI 語音' }
  },
  {
    path: '/agent',
    name: 'Agent',
    component: () => import('../views/Agent.vue'),
    meta: { title: 'Agent' }
  },
  {
    // AI 生文（文字內容）：5 個子模塊做成 tab —— 每個 tab 一條子路由，
    // 這樣重新整理/直達連結都能停在同一個 tab（與影片工作台同一套做法）。
    path: '/text',
    redirect: '/text/blog'
  },
  {
    path: '/text/:tab(blog|social|copy|grouppost|slides)',
    name: 'TextWorkbench',
    component: () => import('../views/TextWorkbench.vue'),
    meta: { title: 'AI 生文' }
  },
  {
    path: '/jobs',
    name: 'JobCenter',
    component: () => import('../views/JobCenter.vue'),
    meta: { title: '任務中心', requiresAuth: true }
  },
  {
    path: '/materials',
    name: 'MaterialLib',
    component: () => import('../views/MaterialLib.vue'),
    meta: { title: '素材庫' }
  },
  // 「範本管理」已移到**管理端**（管理端侧边栏「提示詞範本」）：
  // 提示词是平台级配置，用户改了会影响所有人的出图，不该开放给用户端。
  // 客户端入口与弹窗均已移除；老链接重定向到首页，避免 404。
  {
    path: '/prompts',
    redirect: '/home'
  },
  {
    path: '/recharge',
    name: 'Recharge',
    component: () => import('../views/Recharge.vue'),
    meta: { title: '儲值', requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue'),
    meta: { title: '個人中心', requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 需要开通才可进入的模块：key 与后端 CustomerKit.MODULE_KEYS 一致
const ROUTE_MODULE = {
  '/workbench': 'image',
  '/workbench/competitor': 'competitor',
  '/video': 'video',
  // 影片畫質提升掛在「影片」模組下（不單獨開模組）：沒開影片的客戶本來也用不到
  '/video/upscale': 'video',
  // 影片合成 / AI 字幕 / AI 去字幕 / AI 語音：同樣掛在「影片」模組下
  '/video/compose': 'video',
  '/video/subtitle': 'video',
  '/video/erase-subtitle': 'video',
  '/video/voice': 'video',
  '/video/remake': 'video_remake',
  '/materials': 'materials'
}

// AI 生文是子路由（/text/blog、/text/slides…），模組 key 統一成 text：
// 這裡按前綴匹配，免得每加一個 tab 就要回來補一行。
const ROUTE_MODULE_PREFIX = {
  '/text/': 'text'
}

/** 按前缀找模块 key（子路由用）；没配返回空 */
function moduleByPrefix(path) {
  const p = path || ''
  const keys = Object.keys(ROUTE_MODULE_PREFIX)
  for (let i = 0; i < keys.length; i++) {
    if (p.indexOf(keys[i]) === 0) {
      return ROUTE_MODULE_PREFIX[keys[i]]
    }
  }
  return ''
}

// 全局守卫：全站可自由浏览，只有标注 meta.requiresAuth 的页面才要求登录（弹窗、不跳转）
// 未登录时 modules 为 null，hasModule 放行，所以工作台/素材库都能进去看
router.beforeEach((to, from, next) => {
  const logged = store.getters.isLoggedIn
  if (to.path === '/login') {
    next() // 登录页可访问
    return
  }
  // 需要登录的页面：不再跳转登录页，改为原地弹登录框（登录后回到原页）
  if (to.meta && to.meta.requiresAuth && !logged) {
    store.dispatch('openLogin', to.fullPath)
    if (from ? from.name : null) {
      next(false) // 站内点击：留在原页，只弹登录框
    } else {
      next('/home') // 直接输网址进来：先落到首页
    }
    return
  }
  // 菜单保留、点击给提示：未开通的模块不放行
  const need = ROUTE_MODULE[to.path] || moduleByPrefix(to.path)
  if (need) {
    if (!store.getters.hasModule(need)) {
      const label = to.meta ? to.meta.title : ''
      Message.warning('「' + (label ? label : '該模組') + '」未開通，請聯絡管理員開通後再使用')
      if (from ? from.name : null) {
        next(false) // 站内点击：留在原页
      } else {
        next('/home') // 直接输网址进来：落到首页（首页不依赖任何单个模块）
      }
      return
    }
  }
  next()
})

router.afterEach(to => {
  document.title = (to.meta && to.meta.title ? to.meta.title + ' - ' : '') + '創視魔方'
})

export default router
